module.exports = __webpack_public_path__ + "img/favicon.91744519.ico";